/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step2_BodyInputs */

const es_landing_step2_body = /** @type {(inputs: Landing_Step2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si quieres, te gestionamos la ITB obligatoria y te ayudamos a buscar seguro, todo desde la web. Tú eliges.`)
};

const gl_landing_step2_body = /** @type {(inputs: Landing_Step2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se queres, xestionamos a ITB obrigatoria e axudámoste a buscar seguro, todo dende a web. Ti elixes.`)
};

const en_landing_step2_body = /** @type {(inputs: Landing_Step2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you want, we handle the mandatory ITB inspection and help you find insurance — all online. Your choice.`)
};

/**
* | output |
* | --- |
* | "If you want, we handle the mandatory ITB inspection and help you find insurance — all online. Your choice." |
*
* @param {Landing_Step2_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_step2_body = /** @type {((inputs?: Landing_Step2_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step2_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_step2_body(inputs)
	if (locale === "en") return en_landing_step2_body(inputs)
	return es_landing_step2_body(inputs)
});